import React, { Component, useRef } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Redirect } from 'react-router-dom'
import Select from 'react-select'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'


const estadoInicial = {
  empresasOptions: [],
  empresa: 0,
  textOptions: "",

  redirect: false,
};

class AdminRS extends Component {

  state = {
    ...estadoInicial,
  };

  componentDidMount = async () => {
    this.alteraEmpresa();
  };

  alteraEmpresa = async () => {
    const empresasOptions = await apiEmployee
      .get(`pegarempresasadmin`)
      .then((res) => res.data)
      .catch((err) => []);

    await this.setState({
      empresasOptions: [
        { label: "---", value: "" },
        ...empresasOptions.map((b) => ({ label: b.Nome, value: b.Chave })),
      ],
    })
  };

  entrarEmpresa = () => {
    localStorage.setItem('empresaID', this.state.empresa);
    this.setState({redirect: true});
  }

  render() {
    const validations = []
    validations.push(this.state.empresa != 0);

    const validForm = validations.reduce((t, a) => t && a)
    return (
      <div className="page">
        {this.state.redirect && 
          <Redirect to={`pedidos/`}/>
        }
        <Header />
        <div className="centrom">
          <div className={`col-sm-12 col-md-12 col-lg-9 col-xl-9 row`}>
            <div className="form_body">
              <div className="col-12 contcard">
                <span>Empresa *</span>
                <Select
                  placeholder="Selecione a empresa"
                  value={this.state.empresasOptions.find(
                    (opt) => opt.value === this.state.empresa
                  )}
                  options={this.state.empresasOptions}
                  onChange={(a) => {
                    this.setState({
                      empresa: a.value,
                    });
                  }}
                  onInputChange={(a) => this.setState({ textOptions: a })}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <button 
                  className="button_salvar"
                  disabled={!validForm}
                  onClick={() => validForm ? this.entrarEmpresa() : {}}
                >
                  Entrar
                  </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    token: user.token,
    id: user.id,
    cnpj_cpf: user.cnpj_cpf,
    nome: user.nome,
    empresa: user.empresa,
  };
};

export default connect(mapStateToProps, null)(AdminRS);
